import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const EliminarSalida = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/administracion-inventario/salida/eliminar/movimiento`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        eliminarSalidaMutation: mutation.mutate,
    };
}